import type {StateCreator} from 'zustand'
import type {DiffLineKey, FileKey, LineKey} from '../../types'

export type MoveNewCommentSlice = {
  startNewConversationForLineOrFileMap: {
    [key: LineKey | FileKey]: MoveCommentData
  }
  getMoveNewCommentDataForLine: (lineKey: LineKey | FileKey) => MoveCommentData | undefined
  addStartNewCommentOnLine: (
    lineKey: LineKey | FileKey,
    startNewConversationForLine: () => void,
    verboseLineKey: DiffLineKey,
  ) => void
}

export const FileLevelCode = 'F0' as FileKey

export type MoveNewCommentSliceOpts = {
  startNewConversationForLineOrFileMap: {[key: LineKey | FileKey]: MoveCommentData}
}

export type MoveCommentData = {
  diffLineKey: DiffLineKey
  startNewComment: () => void
}

export const createMoveNewCommentSlice =
  ({
    startNewConversationForLineOrFileMap,
  }: MoveNewCommentSliceOpts): StateCreator<
    MoveNewCommentSlice,
    [['zustand/devtools', never]],
    [],
    MoveNewCommentSlice
  > =>
  (_, get) => ({
    startNewConversationForLineOrFileMap,
    getMoveNewCommentDataForLine: (lineKey: LineKey | FileKey) => {
      const startNewConversationForLineMap = get().startNewConversationForLineOrFileMap
      return startNewConversationForLineMap[lineKey]
    },
    addStartNewCommentOnLine: (
      lineKey: LineKey | FileKey,
      startNewConversationForLine: () => void,
      verboseLineKey: DiffLineKey,
    ) => {
      startNewConversationForLineOrFileMap[lineKey] = {
        diffLineKey: verboseLineKey,
        startNewComment: startNewConversationForLine,
      }
    },
  })
